import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
// THIS IS THE ENTRY POINT FOR REACT:  YOU CAN TOGGLE BETWEEN ./App-stream.jsx and ./App-ask.jsk  
// the filenames reflect the URL ENDPOINT that the chat calls on the server side: STREAM uses tokens and sinks, ASK is a regular request-response
// ./App-ask.jsk --> orginal request-response client , BUT it DOES NOT SCROll doesn properly
// ./App-ask2.jsk --> scrolls down and shows conversation properly, connects to groq a super-fast REMOTE LLM. BEST VERSION AS OF Jul 29 2026
import App from './App-ask2.jsx'


createRoot(document.getElementById('root')).render(
     <App />
)
